

export const AUTH_METHODS = {
    GOOGLE: 'GOOGLE',
    MICROSOFT: 'MICROSOFT',
    XERO: 'XERO'
}

export default {
    AUTH_METHODS
}
